import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  CaregiverType,
  EventType,
  PaymentStatus,
} from '../../shared/models/request-round/request-record.interface';

export interface ServiceRecordSearchResult {
  event: {
    id: string;
    requestId: number;
    startDate: string;
    endDate: string;
    eventType: EventType;
    caregiverId: string | null;
    caregiverName: string;
    caregiverType: CaregiverType;
    hoursWorked: number;
    paymentStatus: PaymentStatus;
    paymentLink: string | null;
    sessionAmount: number;
    discounted: boolean;
    notes: string | null;
    createdAt: string;
    updatedAt: string;
  };
  request: {
    requestId: number;
    clientName: string;
    clientEmail: string;
    clientPhone: string;
    businessLine: string;
    customerType: string;
    b2bCompanyName: string | null;
  };
}

@Injectable({
  providedIn: 'root',
})
export class ServiceAlertsService {
  private baseUrl = environment.baseURL;

  constructor(private http: HttpClient) {}

  find(paymentStatus: PaymentStatus[], operatorUid: string): Observable<ServiceRecordSearchResult[]> {
    return this.http.post<ServiceRecordSearchResult[]>(
      `${this.baseUrl}/request-service-records/find`,
      { paymentStatus, operatorUid },
    );
  }
}
